import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'app/shared/services/api.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-detail',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.scss']
})
export class DetailComponent implements OnInit {

  id:any 
  collection_data:any=[]
  constructor(public apiService:ApiService,private activatedroute: ActivatedRoute,
              private router: Router,public toastr: ToastrService,) { 
                this.activatedroute.paramMap.subscribe(params => { 
                  this.id = params.get('id');
                  if(this.id){
                    this.getTagDeatil(this.id)
                  }
                });
              }

  ngOnInit(): void {
   
  }
  getTagDeatil(id){
    this.apiService.getKnowledgeBaseById(id).subscribe((res:any)=>{
      this.collection_data = res?.data[0]
      this.changeQueryParameter(res?.data[0]?.id)
    })
  }
  changeQueryParameter(newValue: string) {
    // Get the current URL tree.
    const urlTree = this.router.parseUrl(this.router.url);
  
    // Update the query parameter value.
    urlTree.queryParams['id'] = newValue;
    console.log(newValue)
    // Navigate to the updated URL.
    this.router.navigateByUrl(urlTree.toString());
  }
  selectTag(data: any) {
    var name = data.name;
    name = name.toLowerCase();
    name = name.replace(/ /g, "-");
    name = name.replace(/\?/g, "-");
    this.router.navigate(['knowledge-base/collections/',  data._id])
  }

  back() {
    this.router.navigate(['knowledge-base/tags-list'])
  }
  copyToClipboard(val: string) {
    const textWithoutTags = val.replace(/<\/?[^>]+(>|$)/g, '\n');
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = textWithoutTags;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.toastr.info('Content copied')
  }
}
